import * as React from 'react'
import {CompanyProvider} from "./company-context";
import {SnackbarProvider} from "./snackbar-context";
import {CurrencyProvider} from "./currency-context";
import {SystemAlertProvider} from "./system-alert-context";


function AppProviders({children}) {
    return (
        <SystemAlertProvider>
            <SnackbarProvider>
                <CurrencyProvider>
                    <CompanyProvider>
                        {children}
                    </CompanyProvider>
                </CurrencyProvider>
            </SnackbarProvider>
        </SystemAlertProvider>


    )
}

export {AppProviders}
